import React, {Component} from 'react';
import {Breadcrumb, Button, Form, Modal, Popup} from 'semantic-ui-react';
import {Link} from 'react-router-dom';
import {Helmet} from "react-helmet";

import CustomDivider from '../../components/extras/CustomDivider';
import DynamicTable from "../../components/extras/DynamicTable";
import {dynamicTableAddOrUpdate, dynamicTableDelete} from "../../actions/DynamicTableDataAction";
import connect from "react-redux/es/connect/connect";
import {showToast} from "../../actions/ToastAction";
import QuestionDialog from "../../components/extras/QuestionDialog";
import WarehouseStockDialog from "../../components/inventories/WarehouseStockDialog";
import {productRecipesDialog} from "../../actions/ProductRecipesDialogActions";
import WarehouseStockData from "../../data/WarehouseStockData";
import update from "react-addons-update";
import WarehouseStockControlData from "../../data/WarehouseStockControlData";
import {selectProduct} from "../../actions/ProductSelectActions";
import BranchOfficeData from "../../data/BranchOfficeData";

let c = require('../../constants');

class StockType extends Component {
    render() {
        return c.WAREHOUSE_STOCK_TYPES.find(stock_type => stock_type.key===this.props.stock_type).text;
    }
}

class ItemName extends Component {

    render() {
        let stock_type = this.props.product ? 'product':this.props.ingredient ? 'ingredient':'recipe'
        let unit = c.UNITS.find((unit) => unit.key===this.props[stock_type].unit ? this.props[stock_type].unit:'un').abbr
        return `${this.props[stock_type].name} - ${unit}`;
    }
}

class Warehouse extends Component {

    constructor(props) {
        super(props);

        let more_actions = [
            this.actionStockButton,
            this.actionMoveStockButton
        ]

        this.state = {
            table: {
                headers: ['Tipo', 'Nombre', 'Cantidad', 'Acciones'],
                name: 'Inventario',
                title: 'Bodega',
                has_actions: true,
                edit: false,
                can_add: true,
                pagination: true,
                delete: true,
                url: 'warehouse-stock',
                values: ['id', 'stock_type', 'product', 'quantity'],
                component_fields:[{stock_type:StockType, product:ItemName}],
                more_actions: more_actions,
                id: 'table_stock'
            },
            modal_update_stock: false,
            selected_item: null,
            update_stock:{
                track_type:1,
                quantity: 1,
                observations: ''
            },
            move_stock:{
                branch_office:null,
                quantity: 1,
                observations: ''
            },
            update_stock_quantity_error: false,
            move_stock_quantity_error: false,
            loading_stock: false,
            modal_move_stock: false,
            moving_stock: false,
            branch_offices:[]
        };
    }

    actionStockButton = (data) => {
        return <Popup
            trigger={<Button icon='box' onClick={()=> {
                this.setState({modal_update_stock:true, selected_item:data.id})
            }}/>}
            content='Inventario'
            position='top left'
            key={`button_ingredient_${data.id}`}
        />;
    }

    actionMoveStockButton = (data) => {
        return <Popup
            trigger={<Button icon='refresh' onClick={()=> {
                this.setState({modal_move_stock:true, selected_item:data.id})
            }}/>}
            content='Mover Inventario'
            position='top left'
            key={`button_ingredient_${data.id}`}
        />;
    }

    componentWillReceiveProps(nextProps){
        if(nextProps.product_select && nextProps.product_select.hasOwnProperty('id')){
            this.props.dynamicTableAddOrUpdate(nextProps.product_select);
        }
    }

    delete = (id) => {
        WarehouseStockData.delete(id, (res) => {
            if (res === null) {
                this.props.dynamicTableDelete(id);
                this.props.showToast({message: 'Elemento Borrado!', type: 'success'});
            } else {
                this.props.showToast({message: 'Tenemos un problema!', type: 'error'});
            }
        });
    };

    async componentDidMount() {
        await this.getBranchOffices();
    }

    handleCloseModalUpdateStock = () => {
        this.setState({modal_update_stock: false, update_stock:{track_type:1, quantity: 1, observations: ''},})
    }

    handleCloseModalMoveStock = () => {
        this.setState({modal_move_stock: false, move_stock:{quantity: 1, observations: ''},})
    }

    handleUpdateStockSubmit = () =>{
        this.setState({loading_stock:true});
        let data = this.state.update_stock
        data.warehouse_stock = this.state.selected_item
        WarehouseStockControlData.add(data, (res) => {
            if (res.save) {
                this.props.selectProduct(res.data);
                this.props.showToast({message: 'Inventario Actualizado!', type: 'success'});
                this.handleCloseModalUpdateStock()
            } else {
                this.props.showToast({
                    show:true,
                    type:'error',
                    message:'Tenemos un problema!'
                });
            }
            this.setState({loading_stock:false});
        });
    }

    handleMoveStockSubmit = () =>{
        this.setState({moving_stock:true});
        let data = this.state.move_stock
        data.warehouse_stock = this.state.selected_item
        WarehouseStockControlData.move(data, (res) => {
            if (res.save) {
                this.props.selectProduct(res.data);
                this.props.showToast({message: 'Inventario Actualizado!', type: 'success'});
                this.handleCloseModalMoveStock()
            } else {
                this.props.showToast({
                    show:true,
                    type:'error',
                    message:'Tenemos un problema!'
                });
            }
            this.setState({moving_stock:false});
        });
    }

    callbackDynamicTable = (response) => {
        if(response.event === 'add'){
            this.props.productRecipesDialog({id: null, is_open:true});
        }else if(response.event === 'edit'){
            this.props.productRecipesDialog({id: null, is_open:true});
        }else if(response.event === 'delete'){
            this.refs.deleteDialog.open('', response.data.id);
        }
    };

    handleStockUpdateChange = (result, key) => {
        let quantity = update(this.state, {
            update_stock: {
                [key]:  {$set: result}
            }
        });
        this.setState(quantity);
    };

    handleStockMoveChange = (result, key) => {
        let quantity = update(this.state, {
            move_stock: {
                [key]:  {$set: result}
            }
        });
        this.setState(quantity);
    };

    async getBranchOffices() {
        await BranchOfficeData.listAll().then(async branch_offices =>{
            this.setState({branch_offices});
            this.handleStockMoveChange(branch_offices[0].key, 'branch_office')
        });
    };


    render() {
        return (
            <div>
                <Helmet>
                    <title>Bodega | Inventarios - Quipuu</title>
                </Helmet>
                <Breadcrumb>
                    <Breadcrumb.Section as={Link} to='/inventories'>Inventarios</Breadcrumb.Section>
                    <Breadcrumb.Divider/>
                    <Breadcrumb.Section active>Bodega</Breadcrumb.Section>
                </Breadcrumb>
                <CustomDivider/>
                <DynamicTable {...this.state.table} callbackDynamicTable={this.callbackDynamicTable}/>
                <WarehouseStockDialog />
                <QuestionDialog ref="deleteDialog" message="Borrar esta elemento" callbackConfirm={this.delete}/>

                <Modal open={this.state.modal_update_stock} dimmer='inverted' size='tiny' onClose={this.handleCloseModalUpdateStock}>
                    <Modal.Header>Actualizar Inventario</Modal.Header>
                    <Modal.Content>
                        <Modal.Description>
                            <Form onSubmit={this.handleUpdateStockSubmit}>
                                <Form.Dropdown
                                    label={'Tipo de Movimiento'}
                                    options={c.WAREHOUSE_STOCK_MOVEMENTS}
                                    value={this.state.update_stock.track_type}
                                    compact
                                    selection
                                    onChange={(e, {value}) => this.handleStockUpdateChange(value, 'track_type')}
                                    placeholder='Tipo de Movimiento'
                                />
                                <Form.Input
                                    label='Cantidad'
                                    placeholder='Cantidad'
                                    type='number'
                                    name='quantity'
                                    min={0}
                                    step={'.01'}
                                    value={this.state.update_stock.quantity}
                                    onChange={(e, {value}) => this.handleStockUpdateChange(value, 'quantity')}
                                    error={this.state.update_stock_quantity_error}
                                />
                                <Form.TextArea
                                    label='Observaciones'
                                    placeholder='Observaciones'
                                    value={this.state.update_stock.observations}
                                    onChange={(e, {value}) => this.handleStockUpdateChange(value, 'observations')}
                                />
                            </Form>
                        </Modal.Description>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button icon='x' labelPosition='left' onClick={this.handleCloseModalUpdateStock} content="Cerrar"/>
                        <Button primary icon='save'
                                labelPosition='left'
                                onClick={this.handleUpdateStockSubmit}
                                disabled={this.state.loading_stock}
                                loading={this.state.loading_stock}
                                content='Agregar'/>
                    </Modal.Actions>
                </Modal>

                <Modal open={this.state.modal_move_stock} dimmer='inverted' size='tiny' onClose={this.handleCloseModalMoveStock}>
                    <Modal.Header>Mover Inventario</Modal.Header>
                    <Modal.Content>
                        <Modal.Description>
                            <Form onSubmit={this.handleMoveStockSubmit}>
                                <Form.Dropdown
                                    label={'Sucursal'}
                                    options={this.state.branch_offices}
                                    value={this.state.move_stock.branch_office}
                                    compact
                                    selection
                                    onChange={(e, {value}) => this.handleStockMoveChange(value, 'branch_office')}
                                    placeholder='Tipo de Movimiento'
                                />
                                <Form.Input
                                    label='Cantidad'
                                    placeholder='Cantidad'
                                    type='number'
                                    name='quantity'
                                    min={0}
                                    step={'.01'}
                                    value={this.state.move_stock.quantity}
                                    onChange={(e, {value}) => this.handleStockMoveChange(value, 'quantity')}
                                    error={this.state.move_stock_quantity_error}
                                />
                                <Form.TextArea
                                    label='Observaciones'
                                    placeholder='Observaciones'
                                    value={this.state.move_stock.observations}
                                    onChange={(e, {value}) => this.handleStockMoveChange(value, 'observations')}
                                />
                            </Form>
                        </Modal.Description>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button icon='x' labelPosition='left' onClick={this.handleCloseModalMoveStock} content="Cerrar"/>
                        <Button primary icon='save'
                                labelPosition='left'
                                onClick={this.handleMoveStockSubmit}
                                disabled={this.state.moving_stock}
                                loading={this.state.moving_stock}
                                content='Agregar'/>
                    </Modal.Actions>
                </Modal>

            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        product_select: state.get('product_select'),
    };
}


function mapDispatchToProps(dispatch){
    return {
        dynamicTableAddOrUpdate(data){
            dispatch(dynamicTableAddOrUpdate(data))
        },
        dynamicTableDelete(data){
            dispatch(dynamicTableDelete(data))
        },
        showToast(data){
            dispatch(showToast(data))
        },
        selectProduct(data) {
            dispatch(selectProduct(data))
        },
        productRecipesDialog(modal) {
            dispatch(productRecipesDialog(modal))
        },
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Warehouse)



// WEBPACK FOOTER //
// ./src/containers/inventories/Warehouse.js